import { render, staticRenderFns } from "./GlobalSettings.vue?vue&type=template&id=58417b47"
import script from "@/views/modules/Administration/js/GlobalSettings.js?vue&type=script&lang=js&external"
export * from "@/views/modules/Administration/js/GlobalSettings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports